$(document).ready(function () {
  //  Load the select options
  loadSelectOptions();
  //  Display all the virtual cards
  loadCardsByTheme("all");

  //  Load cards by the selected theme
  $("#selectCards").change(function () {
    var selectedTheme = $(this).val();
    loadCardsByTheme(selectedTheme);
  });

  //  Show the modal with the selected card
  $("#virtualCardsGrid").on("click", ".gridItem", function () {
    $("#selectedCardImage").prepend(
      '<img src="' + $(this).data("url") + '" />',
    );
    $("#selectedCardImageURL").val($(this).data("url"));
    $("#virtualCardsFormModal").fadeIn();
  });

  //  Update the characters count for the message
  var messageLimit = 1000;
  $("#messageCharactersCount").html(messageLimit + " caractères restants");

  $("#cardMessage").keyup(function () {
    var messageLength = $("#cardMessage").val().length;
    var remainingCharacters = messageLimit - messageLength;

    $("#messageCharactersCount").html(
      remainingCharacters + " caractères restants",
    );
  });

  //  CLOSE THE MODAL:

  //  When the user clicks on 'X'
  $("#closeModal").click(function () {
    hideModal();
  });

  //  When the user presses the 'Esc Key'
  $(document).keyup(function (e) {
    if (e.keyCode == 27) {
      hideModal();
    }
  });

  //  When the user clicks anywhere outside of the modal
  $("#virtualCardsFormModal").click(function () {
    hideModal();
  });
  //  Do nothing when the click in on the modal itself
  $("#modalContent").click(function (e) {
    e.stopPropagation();
  });
});

//  Hide the modal and clear the loaded data
function hideModal() {
  //  Hide the modal by fading it to transparent.
  $("#virtualCardsFormModal").fadeOut();

  //  Remove the prepended card image from the DOM.
  setTimeout(function () {
    $("#selectedCardImage").empty();
  }, 400);

  //  Clear all input and textarea fields in the form
  $("#modalForm").find("input[type=text], input[type=email], textarea").val("");
}

// Load the cards corresponding to the given theme
function loadCardsByTheme(selectedTheme) {
  //  Empty the grid before loading new content
  $("#virtualCardsGrid").empty();
  var lastTheme = "";

  for (var i = 0; i < cards.length; i++) {
    if (selectedTheme == "all" || cards[i].theme_id == selectedTheme) {
      if (lastTheme != cards[i].theme_id) {
        lastTheme = cards[i].theme_id;
        $("#virtualCardsGrid").append(
          '<li class="col-12"><h2 class="mt-4">' +
            cards[i]["theme_" + Shopify.locale] +
            "</h2></li>",
        );
      }

      if (cards[i].pdf) {
        $("#virtualCardsGrid").append(
          '<li class="col"><div class="card-item"><a href="#" class="gridItem" data-url="' +
            cards[i].link +
            '"><img alt="' +
            cards[i].name +
            '" src="' +
            cards[i].link +
            '" /></a><a href="' +
            cards[i].pdf +
            '" class="bg-white fs-3" style="margin-top: -1px;" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-printer-icon lucide-printer"><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6"/><rect x="6" y="14" width="12" height="8" rx="1"/></svg> Imprimer</a></div></li>',
        );
      } else {
        $("#virtualCardsGrid").append(
          '<li class="col"><div class="card-item"><a href="#" class="gridItem" data-url="' +
            cards[i].link +
            '"><img alt="' +
            cards[i].name +
            '" src="' +
            cards[i].link +
            '" /></a></div></li>',
        );
      }
    }
  }
}

//  Load the options for the theme selector
function loadSelectOptions() {
  for (var i = 0; i < cards.length; i++) {
    var optionExists =
      $("#selectCards option[value=" + cards[i].theme_id + "]").length > 0;

    var themeName = "theme_" + $("#shop_locale").val();

    //  Append the option if it does not exists yet
    if (!optionExists) {
      $("#selectCards").append(
        $("<option>", {
          value: cards[i].theme_id,
          text: cards[i][themeName],
        }),
      );
    }
  }
}

